module.exports = __webpack_public_path__ + "static/media/purewatt-logo.756a506b.jpg";